// GENERATED CODE - DO NOT EDIT
export const ShipmentFeeTypeMap = {
    // @deprecated: fee for ordering using the On-Demand Delivery pilot
    ON_DEMAND_DELIVERY: 'on_demand_delivery',
    // fee for ordering only Alto Essentials
    ESSENTIALS_ONLY_DELIVERY: 'essentials_only_delivery',
    // fee for same-day delivery
    SAME_DAY_DELIVERY: 'same_day_delivery',
    NEXT_DAY_DELIVERY: 'next_day_delivery',
    STANDARD_DELIVERY: 'standard_delivery',
    ASAP_DELIVERY: 'asap_delivery',
};
//# sourceMappingURL=shipment_fee_type.js.map